import client from 'client'
import type {
  RegisterNewCompanyRegisterPostMutationRequest,
  RegisterNewCompanyRegisterPostMutationResponse,
  RegisterNewCompanyRegisterPostQueryParams,
  RegisterNewCompanyRegisterPost422,
} from '../../types/RegisterNewCompanyRegisterPost.ts'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { RequestConfig, ResponseConfig, ResponseErrorConfig } from 'client'
import { useMutation } from '@tanstack/react-query'

export const registerNewCompanyRegisterPostMutationKey = () => [{ url: '/register' }] as const

export type RegisterNewCompanyRegisterPostMutationKey = ReturnType<typeof registerNewCompanyRegisterPostMutationKey>

/**
 * @summary Register New Company
 * {@link /register}
 */
export async function registerNewCompanyRegisterPost(
  data: RegisterNewCompanyRegisterPostMutationRequest,
  params?: RegisterNewCompanyRegisterPostQueryParams,
  config: Partial<RequestConfig<RegisterNewCompanyRegisterPostMutationRequest>> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<
    RegisterNewCompanyRegisterPostMutationResponse,
    ResponseErrorConfig<RegisterNewCompanyRegisterPost422>,
    RegisterNewCompanyRegisterPostMutationRequest
  >({ method: 'POST', url: `/register`, params, data, ...requestConfig })
  return res
}

/**
 * @summary Register New Company
 * {@link /register}
 */
export function useRegisterNewCompanyRegisterPost(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<RegisterNewCompanyRegisterPostMutationResponse>,
      ResponseErrorConfig<RegisterNewCompanyRegisterPost422>,
      { data: RegisterNewCompanyRegisterPostMutationRequest; params?: RegisterNewCompanyRegisterPostQueryParams }
    >
    client?: Partial<RequestConfig<RegisterNewCompanyRegisterPostMutationRequest>> & { client?: typeof client }
  } = {},
) {
  const { mutation: mutationOptions, client: config = {} } = options ?? {}
  const mutationKey = mutationOptions?.mutationKey ?? registerNewCompanyRegisterPostMutationKey()

  return useMutation<
    ResponseConfig<RegisterNewCompanyRegisterPostMutationResponse>,
    ResponseErrorConfig<RegisterNewCompanyRegisterPost422>,
    { data: RegisterNewCompanyRegisterPostMutationRequest; params?: RegisterNewCompanyRegisterPostQueryParams }
  >({
    mutationFn: async ({ data, params }) => {
      return registerNewCompanyRegisterPost(data, params, config)
    },
    mutationKey,
    ...mutationOptions,
  })
}